import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Arrival Time Calculator - Calculate Arrival Time Based on Speed and Distance';
const DESCRIPTION = 'The arrival time calculator calculates the arrival time of a person, car, or moving object based on speed and distance.';
const KEYWORDS = 'Arrival time, calculate arrival time, time calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/arrivaltime';
function Calculator() {
    const [distance, setDistance] = useState('');
    const [speed, setSpeed] = useState('');
    const [arrivalTime, setArrivalTime] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!distance || !speed) {
            setError('Please enter the distance and speed correctly.');
            setArrivalTime('');
            return;
        }
        const distanceValue = parseFloat(distance);
        const speedValue = parseFloat(speed);
        if (isNaN(distanceValue) || isNaN(speedValue) || speedValue <= 0) {
            setError('Please enter valid and positive values for distance and speed.');
            setArrivalTime('');
            return;
        }
        const arrivalTimeValue = distanceValue / speedValue;
        setArrivalTime(arrivalTimeValue.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <p>
                                            To calculate arrival time, we need to know the distance to be covered and the speed at which the object is moving.
                                        </p>
                                        <p>
                                            We can calculate the arrival time of a person, truck, car, or any moving object by determining the speed of that moving object, whether it's a person, a vehicle, or a train, and by calculating the distance that this object will cover.
                                            When we calculate the speed at which the object can move and the distance it will cover, we can calculate the arrival time as follows:
                                        </p>
                                        <p><b>Time = Distance Covered / Speed</b></p>
                                        <p>
                                            By knowing the time it takes for the object to arrive, we can pinpoint the exact time it will reach the desired point.
                                        </p>
                                        <p>
                                            Use the following calculator to calculate arrival time based on speed and distance.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Distance (kilometers)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="80"
                                                        value={distance}
                                                        onChange={(e) => setDistance(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Speed (kilometers per hour)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="8"
                                                        value={speed}
                                                        onChange={(e) => setSpeed(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Arrival Time
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {arrivalTime !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Arrival Time (hours): {arrivalTime} hours
                                                                </p>
                                                                <p className='p-3 mb-2 bg-info text-black'>
                                                                    Solution Steps: <br />
                                                                    - Calculate time based on the following formula:
                                                                    Time (hours) = Distance (kilometers) / Speed (kilometers per hour)
                                                                    - Then divide the distance to be covered by the speed to reach the final time.
                                                                </p>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
